module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "修改收货地址",
      "visible": _vm.addAddressVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addAddressVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('areaSelect', {
    ref: "area",
    attrs: {
      "value": _vm.Address,
      "required": "",
      "label-width": "100px"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeAdress),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeAdress", $$v)
      },
      expression: "form.ConsigneeAdress"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系人"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Consignee),
      callback: function($$v) {
        _vm.$set(_vm.form, "Consignee", $$v)
      },
      expression: "form.Consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.ConsigneeTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "ConsigneeTel", $$v)
      },
      expression: "form.ConsigneeTel"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24,
      "align": "center"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v("确认修改")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b4ce8aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SchoolOrder/components/AddressDialog/index.vue
// module id = 1473
// module chunks = 1